import { IScreen } from './iScreen';
import GameScreen from './gameScreen';

class MainMenuScreen implements IScreen{
    option : number = 0;
    options : string[] = [];
    //frame of the last handled pointer press, to dedupe mouse+touch dispatch
    lastPointerFrame : number = -1;

    constructor(){

    }

    // Before a game exists there's nothing to resume/edit/inspect, so the menu
    // only offers starting a run. Once a game is in progress the full menu is
    // shown. Recomputed each frame so it tracks GameScreen.gameStarted.
    currentOptions(): string[] {
        if(GameScreen.gameStarted){
            return ["Resume", "New Game", "Stats", "Options", "Map Editor", "Credits"];
        }
        return ["Start new game", "Options", "Credits"];
    }

    setup(){
        
    }

    windowResized(): void {
        
    }

    draw(){
        buffer.background(0);

        this.options = this.currentOptions();
        if(this.option >= this.options.length){
            this.option = 0;
        }

        //let the mouse highlight whichever option it hovers
        if(!isMobile){
            let pos = this.pointerBufferPos();
            let hovered = this.optionAt(pos.x, pos.y);
            if(hovered !== -1){
                this.option = hovered;
            }
        }

        buffer.stroke(255);
        buffer.strokeWeight(1);
        buffer.line(-200, -buffer.height/2+100, 200, -buffer.height/2+100);

        buffer.noStroke();
        buffer.textAlign(buffer.CENTER, buffer.CENTER);
        buffer.fill(255);
        buffer.textSize(50);
        buffer.text("PiTi Simulator", 0, -buffer.height/2+50);

        buffer.textSize(24);
        for(let i = 0; i < this.options.length; i++){
            if(i == this.option){
                buffer.fill(205 + (p5js.sin(p5js.frameCount / 5.0) * 25), 0, 0);
                buffer.text("> " + this.options[i] + " <", 0, (i - 1) * 32);
            }else{
                buffer.fill(255);
                buffer.text(this.options[i], 0, (i - 1) * 32);
            }
        }
    }

    // Pointer position (mouse or first touch) in buffer/menu coordinates,
    // matching the convention used across the UI.
    pointerBufferPos(): {x: number, y: number} {
        let px = p5js.mouseX;
        let py = p5js.mouseY;
        if(p5js.touches && p5js.touches.length > 0){
            let t = p5js.touches[0] as any;
            px = t.x;
            py = t.y;
        }
        return { x: px/pixelSize - buffer.width/2, y: py/pixelSize - buffer.height/2 };
    }

    // Index of the option under (x, y), or -1. Options are centered on x=0 at
    // y=(i-1)*32 with 24px text, so a fixed band hit-tests them reliably.
    optionAt(x: number, y: number): number {
        for(let i = 0; i < this.options.length; i++){
            let oy = (i - 1) * 32;
            if(Math.abs(x) < 160 && Math.abs(y - oy) < 15){
                return i;
            }
        }
        return -1;
    }

    // Shared by mouse and touch. p5 can dispatch both for one tap, so the
    // frame guard makes sure a single tap only selects once.
    handlePointer(){
        if(this.lastPointerFrame === p5js.frameCount){
            return;
        }
        this.lastPointerFrame = p5js.frameCount;

        this.options = this.currentOptions();
        let pos = this.pointerBufferPos();
        let idx = this.optionAt(pos.x, pos.y);
        if(idx !== -1){
            this.option = idx;
            this.selectOption(this.options[idx]);
        }
    }

    keyPressed(){
        if(isMobile){
            isMobile = false;
            return;
        }
        this.options = this.currentOptions();
        if(this.option >= this.options.length){
            this.option = 0;
        }
        if(p5js.keyCode == p5js.UP_ARROW || p5js.key.toLowerCase() === 'w'){
            this.option--;
            if(this.option < 0){
                this.option = this.options.length - 1;
            }

        }else if(p5js.keyCode == p5js.DOWN_ARROW || p5js.key.toLowerCase() === 's'){
            this.option++;
            if(this.option >= this.options.length){
                this.option = 0;
            }
        }else if(p5js.keyCode == p5js.ENTER || p5js.key == ' '){
            this.selectOption(this.options[this.option]);
        }else if(p5js.keyCode === p5js.ESCAPE){
            //nothing to resume until a game has actually been started
            if(GameScreen.gameStarted){
                currentScreen = "game";
                iScreen = screens[currentScreen];
            }
            return;
        }
    }

    selectOption(option: string){
        if(option === "New Game" || option === "Start new game"){
            //confirm first - starting a run wipes all saved progress
            currentScreen = "confirmNewGame";
        }else if(option === "Stats"){
            currentScreen = "stats";
        }else if(option === "Options"){
            currentScreen = "options";
        }else if(option === "Map Editor"){
            currentScreen = "mapEditor";
        }else if(option === "Credits"){
            currentScreen = "credits";
        }else{ //Resume
            currentScreen = "game";
        }
        iScreen = screens[currentScreen];
    }

    keyReleased(){

    }

    mousePressed(){
        this.handlePointer();
    }

    mouseReleased(){

    }

    touchStarted(){
        this.handlePointer();
    }

    touchEnded(){
        
    }

    touchMoved(): void {
        
    }

    mouseWheel(event: any): void {
        
    }

}

export default MainMenuScreen;